
import React, { useRef } from 'react';
import { Menu } from 'primereact/menu';
import { MenuItem } from 'primereact/menuitem';
import { PanelMenu } from 'primereact/panelmenu';
import './SuprivisorMenu.css';


const SuprivisorMenu = () => {

    let items: MenuItem[] = [
        {
            label: 'Dashboard', icon: 'pi pi-fw pi-palette', url: '/medi/sdashboard'
        },
        {
            label: 'Home', icon: 'pi pi-users',  items: [
                {
                    label: 'Doctors',
                    icon: 'fas fa-user-md',
                    url:'/medi/sdoctors'
                },
                {
                    label: 'Assistants',
                    icon: 'pi pi-user',
                    url:'/medi/sassistantlist',

                },
                {
                    label: 'Linked Assistants',
                    icon: 'pi pi-link',
                    url:'/medi/slinkassistants',
                }
            ]
        },
        {
            label: 'Applications', icon: 'pi pi-fw pi-user', url: '/medi/sapplications'
        },
        {
            label: 'Reports', icon: 'pi pi-users', url: '/medi/sreports'
        },
        {
            label: 'Activities', icon: '', url: '/medi/sactivity'
        },
        




    ];
    const handleItemClick = (event: { item: { url: string } }) => {
        if (event.item.url) {
            window.location.href = event.item.url;
        }
    };

    return (
        <aside className="main-sidebar" >
            <div className=" menu">
                <div className="menu-container" style={{margin:'0px 10px'}}>
                    <PanelMenu model={items} style={{backgroundColor:'#fff'}}/>
                    {/* <PanelMenu model={items} onClick={() => handleItemClick} style={{width:'980px',textAlign:'center'}} />  */}
                </div>
            </div>
        </aside>
    );
};

export default SuprivisorMenu;
